/*
 * Product card image carousel (opgave 5)
 * Lader kunden blade i produktbillederne direkte på kollektionskortet.
 * Desktop: grå pile. Mobil: prikker + swipe. Tap på billedet = ind på produktet.
 * Neutraliserer temaets hover-scrub via CSS (.pc-show styrer visning), så vi ikke rører swatch-logikken.
 */
(function () {
  var SEL = '.product-card--featured-image.thb-hover';

  function init(fig) {
    if (fig.dataset.pcInit) return;
    var link = fig.querySelector('.product-card--featured-image-link');
    if (!link) return;
    var secondaries = [].slice.call(link.querySelectorAll('.product-secondary-image'));
    if (!secondaries.length) return;
    fig.dataset.pcInit = '1';

    var total = secondaries.length + 1; // primærbillede + sekundære
    var idx = 0;

    // Byg prikker forfra (så temaets gamle prik-referencer bliver løsrevet = no-op)
    var nav = fig.querySelector('.product-secondary-images-nav');
    if (!nav) {
      nav = document.createElement('ul');
      nav.className = 'product-secondary-images-nav';
      fig.appendChild(nav);
    }
    nav.innerHTML = '';
    var dots = [];
    for (var i = 0; i < total; i++) {
      var li = document.createElement('li');
      nav.appendChild(li);
      dots.push(li);
    }

    function show(i) {
      i = ((i % total) + total) % total;
      for (var s = 0; s < secondaries.length; s++) secondaries[s].classList.remove('pc-show');
      if (i > 0) {
        var img = secondaries[i - 1];
        img.classList.add('pc-show');
        if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.unveil(img);
      }
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('active', d === i);
      idx = i;
    }

    function stop(e) { e.preventDefault(); e.stopPropagation(); }

    function makeArrow(cls, label, d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pc-arrow ' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      return b;
    }
    var prev = makeArrow('pc-arrow--prev', 'Forrige billede', 'M15 5l-7 7 7 7');
    var next = makeArrow('pc-arrow--next', 'Naeste billede', 'M9 5l7 7-7 7');
    prev.addEventListener('click', function (e) { stop(e); show(idx - 1); });
    next.addEventListener('click', function (e) { stop(e); show(idx + 1); });
    fig.appendChild(prev);
    fig.appendChild(next);

    for (var k = 0; k < dots.length; k++) {
      (function (di) {
        dots[di].addEventListener('click', function (e) { stop(e); show(di); });
      })(k);
    }

    // Swipe på mobil (tap = normal navigation til produktet)
    var sx = 0, sy = 0, tracking = false;
    link.addEventListener('touchstart', function (e) {
      if (!e.touches[0]) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    link.addEventListener('touchend', function (e) {
      if (!tracking || !e.changedTouches[0]) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
        show(idx + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    show(0);
  }

  function initAll(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init når nye kort dukker op (AJAX-filtrering m.m.)
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(SEL)) init(n);
        else if (n.querySelectorAll) initAll(n);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
